exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".modal-text[data-v-739ca260]{font-size:16px;padding:0 60px}.modal-items[data-v-739ca260]{border:1px solid #fff;padding:24px;margin:0 -46px}.modal-items li[data-v-739ca260]{margin-bottom:14px}", "", {"version":3,"sources":["F:/myugfront/src/components/distance-finals/distance-final-modal.vue"],"names":[],"mappings":"AACA,6BACE,eAAgB,AAChB,cAAgB,CACjB,AACD,8BACE,sBAAuB,AACvB,aAAc,AACd,cAAgB,CACjB,AACD,iCACE,kBAAoB,CACrB","file":"distance-final-modal.vue","sourcesContent":["\n.modal-text[data-v-739ca260] {\n  font-size: 16px;\n  padding: 0 60px;\n}\n.modal-items[data-v-739ca260] {\n  border: 1px solid #fff;\n  padding: 24px;\n  margin: 0 -46px;\n}\n.modal-items li[data-v-739ca260] {\n  margin-bottom: 14px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-739ca260","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/distance-finals/distance-final-modal.vue
// module id = 896
// module chunks = 3